import React from "react";
import { Form } from "react-bootstrap";

const ReportFilters = ({ searchTerm, setSearchTerm, project, date }) => {
  return (
    <div className="filters-container">
      <Form.Group controlId="formSearch">
        <Form.Control
          type="text"
          placeholder="Digite o termo que deseja pesquisar"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </Form.Group>
    </div>
  );
};

export default ReportFilters;
